import React, { useContext } from "react";

import { DataContext } from "../../../../../providers/GasCheckoutDataProvider";
import Checkbox from "../../../../shared/forms/Checkbox";
import Section from "../../../../shared/Section";
import BillingDeliveryForm from "./BillingDeliveryForm";
import ContactData from "./ContactData";
import DeliveryAddress from "./DeliveryAddress";

const StepDeliveryAddress = () => {
    const dataContext = useContext(DataContext);
    const { deliveryEqualBilling } = dataContext.data;
    const { setDeliveryEqualBilling } = dataContext.actions;

    const handleChange = () => {
        setDeliveryEqualBilling(1 - deliveryEqualBilling);
    };

    return (
        <React.Fragment>
            <Section>
                <ContactData />
            </Section>
            <Section withMargin>
                <DeliveryAddress />
            </Section>
            <Section withMargin>
                <Checkbox
                    checked={deliveryEqualBilling}
                    onClick={handleChange}
                    label="Die Rechnungsadresse weicht von der Lieferadresse ab."
                />
            </Section>
            {deliveryEqualBilling === 1 && <BillingDeliveryForm />}
        </React.Fragment>
    );
};

export default StepDeliveryAddress;
